// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.returnreasons', {
        url: '/returnreasons?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/returnreasons/returnreasons.tpl.html',
            controller: 'ReturnReasonsController as vm'
        }},
        resolve: {
            returnreasons: returnreasonsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function returnreasonsResolver(ReturnReasonsApiService, $stateParams) {
    return ReturnReasonsApiService.getReturnReasons({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function ReturnReasonsController($rootScope, $state, $scope, returnreasons, ReturnReasonsApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.returnreasons = returnreasons;
    vm.selectedReturnReasonId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.returnReasonId; }, function(newValue, oldValue) {
            vm.selectedReturnReasonId = parseInt($state.params.returnReasonId,10);
        });
        $rootScope.$on('ReturnReason.Inserted', function(event, response) {
        });
        $rootScope.$on('ReturnReason.Updated', function(event, response) {
        });
        $rootScope.$on('ReturnReason.Deleted', function(event, response) {
        });
        $rootScope.$on('ReturnReason.Changed', function(event, response) {
            loadReturnReasons();
        });
    }

    function loadReturnReasons() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        ReturnReasonsApiService.getReturnReasons(request).then(function(response) {
            vm.returnreasons = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadReturnReasons();
    }

}

angular
    .module('base.returnreasons', ['returnreasons.api','returnreasons.returnreason'])
    .config(stateConfig)
    .controller('ReturnReasonsController', ReturnReasonsController);
